import { defineStore } from 'pinia'

export const localeStore = defineStore('locale', {
  state: () => ({
    locale: null as "hu" | "en" | null
  }),
  persist: true
})